export function open(menu: HTMLElement): void {
  menu.classList.remove("hidden");
  menu.classList.add("flex");
}

export function close(menu: HTMLElement): void {
  menu.classList.remove("flex");
  menu.classList.add("hidden");
}

export function toggle(menu: HTMLElement): void {
  if (menu.classList.contains("hidden")) {
    open(menu);
  } else {
    close(menu);
  }
}
